export const PHONE_DISPLAY = "098666 34473";
export const PHONE_TEL = "tel:+919866634473";
export const WA_NUMBER = "919866634473";

export const waLink = (
  msg = "Hello Belong Spa, I would like to book a massage session."
) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const ADDRESS =
  "1st Floor, Plot No. 121, Road No. 3, Quthbullapur Main Rd, Opp. Bharat Petrol Pump, Suchitra, Sri Krishna Nagar, Quthbullapur, Hyderabad, Telangana 500055";

export const HOURS = "Open All Days · 10:00 AM – 9:30 PM";

export const MAPS_LINK = "https://maps.app.goo.gl/wFopgnZ7tV3aUjiR6";

export const MAP_EMBED =
  "https://www.google.com/maps?q=17.506688,78.4660116&z=17&output=embed";

export const NAV_LINKS = [
  { name: "Home", path: "/", testid: "nav-link-home" },
  { name: "About Us", path: "/about-us-luxury-spa", testid: "nav-link-about" },
  { name: "Services", path: "/services-luxury-spa", testid: "nav-link-services" },
  { name: "Membership", path: "/membership-luxury-spa", testid: "nav-link-membership" },
  { name: "Contact Us", path: "/contact-us-luxury-spa", testid: "nav-link-contact" },
];

export const SERVICES_PATH = "/services-luxury-spa";

const STD_DURATIONS = ["45 min", "60 min", "90 min", "120 min"];
const LONG_DURATIONS = ["60 min", "90 min", "120 min"];

export const TIME_SLOTS = [
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "01:00 PM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM",
  "05:00 PM",
  "06:00 PM",
  "07:00 PM",
  "08:00 PM",
];

export const SERVICES = [
  {
    slug: "aroma-therapy-massage",
    name: "Aroma Therapy Massage",
    tagline: "Botanical calm for the nervous system",
    short:
      "Gentle oil strokes blended with essential botanical extracts for deep neurological calm and stress relief.",
    long: "Our Aroma Therapy service pairs slow, rhythmic strokes with cold-pressed essential oils chosen for your state of mind — lavender to unwind, eucalyptus to clear, sandalwood to ground. As the oils absorb, the nervous system softens and the body relearns stillness.",
    audience: [
      "First-time spa guests and sensitive nervous systems",
      "High-stress professionals and light sleepers",
      "Anyone who prefers gentle, flowing pressure",
    ],
    benefits: [
      "Dissolves stress and anxiety at the neurological level",
      "Improves sleep quality and emotional balance",
      "Cold-pressed essential oils, blended fresh in-house",
      "The ideal first service for those new to massage",
    ],
    durations: STD_DURATIONS,
    image:
      "https://images.pexels.com/photos/9898734/pexels-photo-9898734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "balinese-massage",
    name: "Balinese Massage",
    tagline: "An island service of flow and harmony",
    short:
      "An exotic Indonesian service blending deep kneading, skin rolling and aromatic oils to stimulate circulation.",
    long: "Born on the island of Bali, this service weaves acupressure, skin rolling and long flowing strokes into one continuous current. Warm aromatic oils carry the work deep into the muscle, restoring circulation and a sense of whole-body harmony.",
    audience: [
      "Those who love medium-firm pressure with a flowing rhythm",
      "Guests seeking a circulation boost and full-body balance",
      "Fans of warm-oil therapies",
    ],
    benefits: [
      "Stimulates blood circulation and lymphatic flow",
      "Releases deep-seated muscular tension",
      "Balances body energy through acupressure points",
      "Leaves skin nourished with warm herbal oils",
    ],
    durations: STD_DURATIONS,
    image:
      "https://images.pexels.com/photos/1926811/pexels-photo-1926811.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "deep-tissue-massage",
    name: "Deep Tissue Massage",
    tagline: "Firm precision for chronic tension",
    short:
      "Targeted firm pressure reaching inner muscle layers and connective tissue to release chronic knots.",
    long: "For bodies that carry their stress in the shoulders, the back, the jaw. Slow, deliberate pressure works layer by layer into the deeper muscle and fascia, unwinding knots that lighter touch cannot reach. Intense, honest, and profoundly relieving.",
    audience: [
      "Athletes, gym-goers and physically active bodies",
      "Desk professionals with chronic neck and back tightness",
      "Those who prefer firm, targeted pressure",
    ],
    benefits: [
      "Releases chronic muscle knots and adhesions",
      "Eases long-standing back, neck and shoulder pain",
      "Improves posture and range of motion",
      "Recommended for athletes and desk-bound professionals",
    ],
    durations: STD_DURATIONS,
    image:
      "https://images.pexels.com/photos/7795790/pexels-photo-7795790.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "thai-massage",
    name: "Thai Massage",
    tagline: "Ancient movement, renewed energy",
    short:
      "An ancient energising discipline of acupressure and yoga-like assisted stretching for flexibility and flow.",
    long: "Practised for over two thousand years, Thai massage is meditation in motion. Your therapist guides you through assisted stretches and rhythmic acupressure along the body's energy lines — no oils, no table, just breath, pressure and release.",
    audience: [
      "Guests who want energy rather than sedation",
      "Stiff bodies needing stretch and mobility",
      "Those who prefer a clothed, oil-free service",
    ],
    benefits: [
      "Restores joint flexibility and mobility",
      "Clears blocked energy along the sen lines",
      "Energises rather than sedates the body",
      "Performed fully clothed on a traditional floor mat",
    ],
    durations: STD_DURATIONS,
    image:
      "https://images.pexels.com/photos/6205896/pexels-photo-6205896.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "four-hand-massage",
    name: "Four Hand Massage",
    tagline: "Two therapists. One symphony.",
    short:
      "Two synchronised therapists working in mirrored rhythm, lulling the mind into complete sensory surrender.",
    long: "Our most indulgent service. Two therapists move in perfect mirrored synchrony — the mind, unable to track four hands at once, simply lets go. What remains is a depth of relaxation that single-therapist work cannot reach.",
    audience: [
      "Guests celebrating something special",
      "Deep relaxers who find single-therapist work too predictable",
      "Anyone wanting our most indulgent signature service",
    ],
    benefits: [
      "Double the coverage, twice the depth of release",
      "Synchronised rhythm quiets the analytical mind",
      "Our most requested signature indulgence",
      "Sessions begin at 60 minutes",
    ],
    durations: LONG_DURATIONS,
    minNote: "Sessions begin at 60 minutes",
    image:
      "https://images.pexels.com/photos/35495081/pexels-photo-35495081.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "body-massage",
    name: "Body Massage",
    tagline: "The complete signature service",
    short:
      "Our signature head-to-toe rejuvenation, designed to ease physical exhaustion and restore vitality.",
    long: "The service Belong was built around. A full head-to-toe journey — scalp to soles — blending Swedish flow, targeted pressure and warm oils. Sixty minutes resets the week; two hours rewires the month.",
    audience: [
      "First-time visitors unsure where to start",
      "Anyone carrying full-body fatigue",
      "Weekly-reset regulars",
    ],
    benefits: [
      "Complete head-to-toe physical renewal",
      "Relieves full-body fatigue and stiffness",
      "Boosts circulation and natural immunity",
      "Our definitive signature experience",
    ],
    durations: STD_DURATIONS,
    image:
      "https://images.unsplash.com/photo-1787651343599-92563927b750?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcGElMjBzdWl0ZSUyMHJvb20lMjBtYXNzYWdlJTIwYmVkcyUyMGxpbmVucyUyMGFtYmllbnQlMjBsaWdodGluZ3xlbnwwfHx8fDE3OTIxNDc0MTZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "jacuzzi-spa",
    name: "Jacuzzi Spa",
    tagline: "Private hydrotherapy in candlelight",
    short:
      "A private hydro-jet soak with mineral salts and ambient candlelight for total muscle decompression.",
    long: "Sink into your own private Jacuzzi suite. Warm hydro-jets work the large muscle groups while mineral salts soften the water and the skin. Candlelight, quiet, and nowhere to be — the perfect prelude or finale to any massage.",
    audience: [
      "Muscle-sore guests needing hydro decompression",
      "Guests wanting private, unhurried soak time",
      "Anyone pairing a soak with a massage service",
    ],
    benefits: [
      "Hydro-jets decompress tired, sore muscles",
      "Mineral salts detoxify and soften the skin",
      "Private suite — never shared, never rushed",
      "Sessions begin at 60 minutes",
    ],
    durations: LONG_DURATIONS,
    minNote: "Sessions begin at 60 minutes",
    image:
      "https://images.unsplash.com/photo-1781736363509-a2327b675a03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxob3QlMjBzdG9uZXMlMjB0cmF5JTIwc3BhJTIwdG93ZWxzJTIwbGluZW5zJTIwZmxvd2VyJTIwZGVjb3J8ZW58MHx8fHwxNzkyMTQ3NDEwfDA&ixlib=rb-4.1.0&q=85",
  },
];

export const MEMBERSHIPS = [
  {
    name: "Silver Sanctuary",
    badge: "The Beginning",
    featured: false,
    features: [
      "2 Body Massage sessions per month (60 min)",
      "10% off all additional services",
      "Complimentary herbal aromatherapy infusions",
      "Priority weekend booking slots",
    ],
  },
  {
    name: "Gold Royalty",
    badge: "Most Devoted",
    featured: true,
    features: [
      "4 Body or Balinese sessions per month",
      "1 complimentary Jacuzzi Spa session (60 min)",
      "20% off all service upgrades",
      "Dedicated personal wellness concierge",
      "Complimentary guest access once a quarter",
    ],
  },
  {
    name: "Platinum Privilege",
    badge: "The Inner Circle",
    featured: false,
    features: [
      "Up to 6 luxury sessions every month",
      "Includes Four Hand Massage & Jacuzzi suites",
      "30% off services for family & friends",
      "Guaranteed private suite reservation",
      "Custom oil blending & herbal tea service",
    ],
  },
];

export const GALLERY = [
  "/images/belong-reception-desk.png",
  "/images/belong-corridor.png",
  "/images/belong-treatment-room.png",
];

export const HERO_IMAGE = "/images/belong-interior-collage.png";

export const ABOUT_IMAGE = "/images/belong-reception-lounge.png";

export const COLLAGE_IMAGE = "/images/belong-interior-collage.png";

export const FAQS = [
  {
    q: "What services does Belong Salon & Spa offer?",
    a: "Belong is a massage-only spa in Suchitra, Hyderabad offering seven services: Aroma Therapy Massage, Balinese Massage, Deep Tissue Massage, Thai Massage, Four Hand Massage, Body Massage and a private Jacuzzi Spa.",
  },
  {
    q: "How long are the massage sessions?",
    a: "Most services run 45, 60, 90 or 120 minutes. Four Hand Massage and Jacuzzi Spa sessions begin at 60 minutes.",
  },
  {
    q: "How do I book a massage at Belong Spa?",
    a: "Book on WhatsApp or call 098666 34473. Pick a service, duration and time slot on the website and the request goes straight to the spa's WhatsApp.",
  },
  {
    q: "Where is Belong Salon & Spa located?",
    a: "1st Floor, Plot No. 121, Road No. 3, Quthbullapur Main Road, opposite Bharat Petrol Pump, Suchitra, Sri Krishna Nagar, Quthbullapur, Hyderabad, Telangana 500055.",
  },
  {
    q: "How much do massages cost at Belong Spa?",
    a: "Prices are shared on request — message on WhatsApp or call 098666 34473 for current session and membership pricing.",
  },
];

export const REVIEWS = [
  {
    quote:
      "The four-hand service felt like a symphony played on the body. I walked out lighter than I have felt in years.",
    author: "Rakesh M.",
    area: "Suchitra",
  },
  {
    quote:
      "Deep tissue here fixed what months of desk work had done to my shoulders. Firm, precise, professional.",
    author: "Anil K.",
    area: "Jeedimetla",
  },
  {
    quote:
      "The Jacuzzi suite is pure luxury — private, candlelit, and the perfect end to a long week.",
    author: "Divya R.",
    area: "Alwal",
  },
  {
    quote:
      "Booked on WhatsApp in two minutes. The Balinese service was worth every minute of the drive.",
    author: "Priya S.",
    area: "Kompally",
  },
  {
    quote:
      "Clean suites, skilled therapists, zero rush. My membership is the best money I spend each month.",
    author: "Imran S.",
    area: "Bowenpally",
  },
  {
    quote:
      "Thai massage left me energised for days. This is now my regular reset spot in Suchitra.",
    author: "Meghana T.",
    area: "Kukatpally",
  },
];
